export default {
  data() {
    return {
      lastPlayTime: 0,
      realPlayTime: 0,
      timer: null,
    };
  },
  mounted() {
    window.addEventListener('beforeunload', this.beforeunloadFn);
    this.countRealTime();
  },
  beforeRouteLeave(to, from, next) {
    this.beforeunloadFn();
    next();
  },
  computed: {
    isCourseType() {
      return this.courseType === '课程';
    },
  },
  methods: {
    beforeunloadFn() {
      this.setVideoChangeSensorsData();
      // 有return则会有弹窗待确认
      // eslint-disable-next-line
      // return e.returnValue = false;
    },
    // 记录真实播放时长
    countRealTime() {
      if (!this.$refs.video) {
        return;
      }

      const increaseRealTime = () => {
        this.realPlayTime += 1;
      };

      this.$refs.video.onplay = () => {
        this.setVideoClickSensorsData('播放');
        this.timer = setInterval(() => {
          increaseRealTime();
        }, 1000);
      };

      this.$refs.video.onpause = () => {
        this.setVideoClickSensorsData('暂停');
        window.clearInterval(this.timer);
      };

      this.$refs.video.onended = () => {
        window.clearInterval(this.timer);
      };
    },
    updateLastPlayTime() {
      if (this.$refs.video) {
        this.lastPlayTime = this.$refs.video.currentTime;
      }
    },
    setVideoClickSensorsData(clickType) {
      this.$sensors.track('course_detail_click', {
        ...this.getCommonData(),
        click_type: clickType,
        teacher_id: this.isCourseType ?
          [(this.currentVideo || {}).videoTeachId] : this.details.traceInfo.teacherId,
      });
    },
    setPageViewSensorsData() {
      this.$sensors.track('course_detail_view', {
        ...this.getCommonData(),
        teacher_id: this.isCourseType ?
          [(this.currentVideo || {}).videoTeachId] : this.details.traceInfo.teacherId,
      });
    },
    getCommonData() {
      const {
        courseDiscountPrice,
        courseId,
        courseName,
        courseOriginalPrice,
        teacherId,
      } = this.details.traceInfo;

      const params = {
        course_id: courseId,
        course_name: courseName,
        course_original_price: courseOriginalPrice,
        course_discount_price: courseDiscountPrice,
        course_type: this.courseType,
      };

      if (teacherId && teacherId.length === 0) {
        params.teacher_id = teacherId;
      }
      return params;
    },
    setVideoChangeSensorsData() {
      const [s, m, h] = this.isCourseType ? ((this.currentVideo || {}).videoHours || '').split(':').reverse() : [0, 0, 0];

      // 未购买的付费课程
      if (this.videoMode !== 2 && this.realPlayTime !== 0 && this.lastPlayTime !== 0) {
        this.$sensors.track('course_video_play', {
          ...this.getCommonData(),
          // 总时长
          // 测试反馈某些情况通过ref获取的时长是0
          video_time: Number((this.$refs.video || {}).duration.toFixed()) ||
            (h || 0) * 60 * 60 + (m || 0) * 60 + (+s || 0),
          // 进度时长
          progress_time: Number(this.lastPlayTime.toFixed(0)),
          // 真实观看时长
          play_time: Number(this.realPlayTime.toFixed(0)),
          // 直播有的没有videoId
          video_id: this.details.videoId || this.currentVideoId,
          // 直播无视频名字
          video_name: this.currentVideoName,
          teacher_id: this.isCourseType ?
            [(this.currentVideo || {}).videoTeachId] : [this.details.traceInfo.teacherId[0]],
        });
      }

      if (this.timer) {
        window.clearInterval(this.timer);
      }
      this.realPlayTime = 0;
      this.lastPlayTime = 0;
    },
  },
};
